import { render, staticRenderFns } from "./CommunityCaseCard.vue?vue&type=template&id=46696f44&scoped=true"
import script from "./CommunityCaseCard.vue?vue&type=script&lang=js"
export * from "./CommunityCaseCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityCaseCard.vue?vue&type=style&index=0&id=46696f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46696f44",
  null
  
)

export default component.exports